import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function Section({ n, title, children, testId }) {
  return (
    <section className="bg-white border border-stone-200 rounded-2xl p-5 sm:p-7" data-testid={testId}>
      <h2 className="font-display text-base md:text-lg font-semibold text-[#1C352D] mb-4 flex items-baseline gap-3">
        <span className="text-[#C2410C] font-mono text-sm">{String(n).padStart(2, "0")}</span>{title}
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export function Field({ label, k, f, set, required, type = "text", area, placeholder, disabled, className = "" }) {
  const C = area ? Textarea : Input;
  return (
    <div className={className}>
      <Label className="text-xs text-stone-600">{label}{required && <span className="text-[#C2410C]"> *</span>}</Label>
      <C type={type} value={f[k] || ""} onChange={(e) => set(k, e.target.value)} placeholder={placeholder} disabled={disabled}
        required={required} className="mt-1.5" rows={area ? 3 : undefined} data-testid={`enr-${k}`}/>
    </div>
  );
}

export function Choice({ value, onChange, options, name }) {
  return (
    <div className="flex flex-col gap-2">
      {options.map(([v, l, hint]) => (
        <label key={String(v)} className={`flex items-start gap-3 rounded-lg border px-3 py-2.5 cursor-pointer transition-colors ${value === v ? "border-[#1C352D] bg-[#1C352D]/5" : "border-stone-200 hover:border-stone-400"}`}
          data-testid={`enr-${name}-${String(v)}`}>
          <input type="radio" name={name} checked={value === v} onChange={() => onChange(v)} className="mt-1 accent-[#1C352D]"/>
          <span className="text-sm"><span className="font-medium">{l}</span>{hint && <span className="block text-xs text-stone-500">{hint}</span>}</span>
        </label>
      ))}
    </div>
  );
}

export function Consent({ k, f, set, children }) {
  return (
    <div className="rounded-lg border border-stone-200 p-3 sm:p-4" data-testid={`enr-consent-${k}`}>
      <p className="text-xs text-stone-600 leading-relaxed mb-3">{children}</p>
      <div className="flex gap-2">
        {[[true, "Acconsento"], [false, "Non acconsento"]].map(([v, l]) => (
          <button key={l} type="button" onClick={() => set(k, v)} data-testid={`enr-${k}-${v ? "yes" : "no"}`}
            className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${f[k] === v ? "bg-[#1C352D] text-white border-[#1C352D]" : "bg-white border-stone-300 text-stone-600 hover:border-stone-500"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export function FilePick({ kind, label, files, setFiles, required }) {
  const list = files[kind] || [];
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 justify-between rounded-lg border border-stone-200 px-3 py-2.5">
      <div className="text-sm">{label}{required && <span className="text-[#C2410C]"> *</span>}
        {list.length > 0 && <div className="text-[11px] text-emerald-700">{list.map((x) => x.name).join(", ")}</div>}</div>
      <label className="text-xs px-3 py-1.5 rounded-full border border-stone-300 cursor-pointer hover:border-[#1C352D] self-start sm:self-auto">
        {list.length ? "Sostituisci" : "Scegli file"}
        <input type="file" accept=".pdf,image/*" multiple className="hidden" data-testid={`enr-file-${kind}`}
          onChange={(e) => setFiles({ ...files, [kind]: Array.from(e.target.files || []) })}/>
      </label>
    </div>
  );
}
